import {
  FormControl,
  FormHelperText,
  Grid,
  Typography,
  Autocomplete,
} from "@mui/material";
import { Box } from "@mui/system";
import { useFormik } from "formik";
import React from "react";
import * as yup from "yup";

import { StyledTextField } from "../../../customComponents/styled/styledInputs";
import { StyledLoadingButton } from "../../../customComponents/styled/styledButtons";
import { useCreateSectionMutation } from "./sectionsApiSlice";
import { useGetTeachersPaginatedQuery } from "../../staff/staffApiSlice";
import toast from "../../../../helpers/toast";

const sectionFormValidation = yup.object({
  name: yup.string().required("Required"),
  head_title: yup.string().required("Required"),
  head_id: yup.string().required("Required"),
});

function AddSectionForm() {
  const [createSection, { isLoading: creatingSession }] =
    useCreateSectionMutation();
  const [teacherSearch, setTeacherSearch] = React.useState("");
  const { data: teachersData } = useGetTeachersPaginatedQuery({ page: 1, per_page: 10, q: teacherSearch });
  const teachers = teachersData?.teachers ?? [];

  const sectionForm = useFormik({
    initialValues: {
      name: "",
      head_title: "",
      head_id: 0,
    },
    enableReinitialize: true,
    validationSchema: sectionFormValidation,
    onSubmit: async (values) => {

      try {
        const response = await createSection(values).unwrap();
        if (response.id) {
          toast.success("Section created successfully");
          sectionForm.resetForm();
        } else {
          toast.error("Section creation failed");
        }
      } catch (error) {
        toast.error(error?.message || "Something went wrong");
      }
    },
  });

  return (
    <>
      <Box className="paperHeader">
        <Typography variant="formHeading">Setup Sections</Typography>
      </Box>
      <Box className="paperBody">
        <form onSubmit={sectionForm.handleSubmit}>
          <Grid container columnSpacing={1} rowSpacing={2}>
            <Grid item xs={12}>
              <FormControl error fullWidth>
                <Typography variant="formSubHeading">Section Name</Typography>
                <StyledTextField
                  variant="outlined"
                  id="name"
                  name="name"
                  value={sectionForm.values.name}
                  onChange={sectionForm.handleChange}
                  error={
                    sectionForm.touched.name && Boolean(sectionForm.errors.name)
                  }
                />
                <FormHelperText variant="error">
                  {sectionForm.touched.name && sectionForm.errors.name}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl error fullWidth>
                <Typography variant="formSubHeading">
                  HEAD'S TITLE (E.G: HEAD TEACHER)
                </Typography>
                <StyledTextField
                  variant="outlined"
                  id="head_title"
                  name="head_title"
                  value={sectionForm.values.head_title}
                  onChange={sectionForm.handleChange}
                  error={
                    sectionForm.touched.head_title &&
                    Boolean(sectionForm.errors.head_title)
                  }
                />
                <FormHelperText variant="error">
                  {sectionForm.touched.head_title &&
                    sectionForm.errors.head_title}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={12}>
              <FormControl fullWidth>
                <Typography htmlFor="head_id" variant="formSubHeading">
                  SELECT STAFF
                </Typography>
                <Autocomplete
                  options={teachers}
                  getOptionLabel={(option) => option ? `${option.first_name} ${option.last_name}` : ""}
                  isOptionEqualToValue={(option, value) => option.user_id === value.user_id}
                  value={teachers.find(t => t.user_id === sectionForm.values.head_id) || null}
                  onChange={(_, value) => sectionForm.setFieldValue("head_id", value?.user_id || "")}
                  onInputChange={(_, value, reason) => { if (reason === "input") setTeacherSearch(value); }}
                  filterOptions={(x) => x}
                  renderInput={(params) => (
                    <StyledTextField
                      {...params}
                      placeholder="Search staff..."
                    />
                  )}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} textAlign={"right"}>
              <StyledLoadingButton loading={creatingSession} type="submit">
                submit
              </StyledLoadingButton>
            </Grid>
          </Grid>
        </form>
      </Box>
    </>
  );
}

export default AddSectionForm;
